const GAME_STATES = {
    INITIALIZED: 'initialized',
    PLAYING: 'playing',
    STOPPED: 'stopped'
};

export default GAME_STATES;
